<div class="authentification">
    <div class="avatar"></div>
    <div class="home">
        <a routerLink="/">
            <div class="icon-home">
                <i class="glyphicon glyphicon-home"></i>
            </div>
            <span>Accueil</span>
        </a>
    </div>
    <div class="auth-content">
        <div class="text-center logo">
            <img src="assets/images/logos/logo.png" alt="logo" width="170">
        </div>
        <router-outlet></router-outlet>
    </div>
</div>